import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import {
  AccentedTableRow,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';
import { OppvarmingVed } from '../../../../../../types/registration/userInput';

interface OppvarmingVedProps {
  ved: OppvarmingVed | undefined;
}
export const OppvarmingVedView: FC<OppvarmingVedProps> = ({ ved }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.ved' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  return (
    ved && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>

        {ved.installasjonsArApenPeis && (
          <TableRow>
            <TableCell>{t('installasjonsArApenPeis')}</TableCell>
            <LeftBorderCell>{ved.vetInstallasjonsArApenPeis ? ved.installasjonsArApenPeis : tCommon('innstallasjonsArUkjent', { byggAr: ved.installasjonsArApenPeis })}</LeftBorderCell>
          </TableRow>
        )}
        {ved.installasjonsArPeisMedDor && (
          <TableRow>
            <TableCell>{t('installasjonsArPeisMedDor')}</TableCell>
            <LeftBorderCell>{ved.vetInstallasjonsArPeisMedDor ? ved.installasjonsArPeisMedDor : tCommon('innstallasjonsArUkjent', { byggAr: ved.installasjonsArPeisMedDor })}</LeftBorderCell>
          </TableRow>
        )}
        {ved.installasjonsArLukketOvn && (
          <TableRow>
            <TableCell>{t('installasjonsArLukketOvn')}</TableCell>
            <LeftBorderCell>{ved.vetInstallasjonsArLukketOvn ? ved.installasjonsArLukketOvn : tCommon('innstallasjonsArUkjent', { byggAr: ved.installasjonsArLukketOvn })}</LeftBorderCell>
          </TableRow>
        )}
      </Fragment>
    )
  );
};
